import React from 'react';
import { Building2, Users, Award, Shield } from 'lucide-react';
import i18n from '../i18n/config';

interface FeatureProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}

const Feature: React.FC<FeatureProps> = ({ icon, title, description, color }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-lg border border-[#3498db]/10 hover:border-[#3498db]/30 transition-all duration-300">
      <div className={`flex items-center justify-center h-12 w-12 rounded-md text-white mb-4`} style={{ backgroundColor: color }}>
        {icon}
      </div>
      <h3 className="text-lg font-medium text-[#2c3e50] mb-2">{title}</h3>
      <p className="text-[#2c3e50]/80">{description}</p>
    </div>
  );
};

const AboutUs: React.FC = () => {
  return (
    <section id="about-us" className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-[#2c3e50] sm:text-4xl">
            {i18n.t('about.title')}
          </h2>
          <p className="mt-4 text-lg text-[#2c3e50]/80 max-w-3xl mx-auto">
            {i18n.t('about.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <Feature
            icon={<Building2 className="h-6 w-6" />}
            title={i18n.t('about.company.title')}
            description={i18n.t('about.company.description')}
            color="#3498db"
          />
          <Feature
            icon={<Users className="h-6 w-6" />}
            title={i18n.t('about.team.title')}
            description={i18n.t('about.team.description')}
            color="#1abc9c"
          />
          <Feature
            icon={<Award className="h-6 w-6" />}
            title={i18n.t('about.expertise.title')}
            description={i18n.t('about.expertise.description')}
            color="#f1c40f"
          />
          <Feature
            icon={<Shield className="h-6 w-6" />}
            title={i18n.t('about.security.title')}
            description={i18n.t('about.security.description')}
            color="#2c3e50"
          />
        </div>

        <div className="mt-12 text-center">
          <a
            href="/contact"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#3498db] hover:bg-[#2980b9] transition-colors duration-200"
          >
            {i18n.t('contact.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutUs; 